import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';

const bunnings = createReducer(
  {},
  {
    [ActionTypes.LOAD_BUN_CATEGORY]: (state, { payload }) => {
      return { ...state, enquiryCategory: payload };
    }
  }
);

export default bunnings;
